module.exports = __webpack_public_path__ + "images/11b274ea19d442e8cb9bcba93ed865e0.svg";